import { useEffect, useRef } from 'react';

const PatentSection = () => {
  const titleRef = useRef<HTMLDivElement>(null);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
          }
        });
      },
      { threshold: 0.1 }
    );
    [titleRef, cardRef].forEach((r) => r.current && observer.observe(r.current));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="patent" className="py-24 bg-[#F8F9FC]">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">

        {/* 타이틀 */}
        <div
          ref={titleRef}
          className="text-center mb-14 opacity-0 translate-y-6 transition-all duration-700"
        >
          <span className="text-[#FF6B35] text-sm font-semibold tracking-widest uppercase">
            Patent Certificate
          </span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-bold text-[#1B2A4A] font-display">
            특허 등록 완료
          </h2>
          <p className="mt-4 text-gray-500 text-base max-w-xl mx-auto">
            대한민국 지식재산처 특허증 취득 완료
          </p>
          <div className="mt-4 w-12 h-1 bg-[#FF6B35] mx-auto rounded-full" />
        </div>

        {/* 특허 완료 카드 */}
        <div
          ref={cardRef}
          className="w-full flex justify-center opacity-0 translate-y-8 transition-all duration-700 delay-100"
        >
          <div className="relative w-full max-w-[620px] rounded-2xl bg-[#1B2A4A] border border-[#FF6B35]/30 overflow-hidden px-8 py-12 text-center">
            {/* 배경 장식 */}
            <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-[#FF6B35]/10" />
            <div className="absolute -bottom-20 -left-16 w-56 h-56 rounded-full bg-[#FF6B35]/5" />

            <div className="relative flex flex-col items-center">
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-[#FF6B35]/15 mb-6">
                <i className="ri-award-fill text-[#FF6B35] text-3xl" />
              </div>

              <span className="inline-flex items-center gap-1.5 bg-[#FF6B35] text-white text-xs font-bold px-3.5 py-1.5 rounded-full whitespace-nowrap">
                <i className="ri-check-line text-sm" />
                특허 완료
              </span>

              <p className="mt-6 text-2xl sm:text-3xl font-bold text-white font-display leading-snug break-keep">
                2026년 7월 30일 (특허 완료)
              </p>

              <div className="mt-6 w-10 h-px bg-white/20" />

              <p className="mt-5 text-white/60 text-sm leading-relaxed break-keep">
                방수 패킹이 구비된 지붕캡
              </p>
              <p className="mt-1.5 text-white/40 text-xs">
                대한민국 지식재산처 정식 등록 특허
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default PatentSection;